export default __webpack_public_path__ + "static/media/Test6.3aa20715.PNG";